module.exports = {
  url: "/api" // https://wp.maoban.net
};
